import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { AssessmentRowComponent } from '../assessment-row/assessment-row.component';
import { EmrInputComponent } from "../../../../shared/emr-input/emr-input.component";
import { EmrCheckboxGroupComponent } from "../../../../shared/emr-checkbox-group/emr-checkbox-group.component";
import { EmrCheckboxComponent } from "../../../../shared/emr-checkbox/emr-checkbox.component";
import { FormOption } from 'src/app/shared/models/form-option.model';
import { GeneralAppearanceFormGroup } from 'src/app/calvin-emr-shared/models/assessments/general-appearance.model';
import { Patient } from 'src/app/calvin-emr-shared/models/patient.model';
import { WnlGroupDirective } from '../wnl/wnl-group.directive';
import { WnlControlDirective } from '../wnl/wnl-control.directive';

@Component({
  selector: 'app-general-appearance-form',
  templateUrl: './general-appearance-form.component.html',
  styleUrls: ['./general-appearance-form.component.scss', '../assessments-tab.component.scss'],
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    CommonModule,
    MatCheckboxModule,
    FormsModule,
    ReactiveFormsModule,
    AssessmentRowComponent,
    EmrInputComponent,
    EmrCheckboxComponent,
    EmrCheckboxGroupComponent,
    WnlGroupDirective,
    WnlControlDirective,
  ],
})
export class GeneralAppearanceFormComponent {

  formGroup = input.required<GeneralAppearanceFormGroup>();
  patient = input.required<Patient>();

  reset() {
    this.formGroup().enable({ emitEvent: false });
  }

  get areBreastsAbnormal(): boolean {
    return !!this.formGroup().controls.hasBreastAbnormalities.value;
  }

  get supportPersonAtBedside(): boolean {
    return !!this.formGroup().controls.supportPersonAtBedside.value;
  }

  locOptions = [
    new FormOption('Lethargic'),
    new FormOption('Somnolent'),
    new FormOption('WNL'),
  ];

  pediatricOrientationOptions = [
    new FormOption('NOT TO person', 'person'),
    new FormOption('NOT TO place', 'place'),
    new FormOption('NOT TO time', 'time'),
    new FormOption('NOT TO situation', 'situation'),
    new FormOption('Cries', 'cries'),
    new FormOption('Grunts', 'grunts'),
    new FormOption('Unable to assess', 'unableToAssess'),
  ];

  orientationOptions = [
    new FormOption('NOT TO person', 'person'),
    new FormOption('NOT TO place', 'place'),
    new FormOption('NOT TO time', 'time'),
    new FormOption('NOT TO situation', 'situation'),
  ];

  supportPersonTypeOptions = [
    new FormOption('Parent/Guardian'),
    new FormOption('Sibling'),
    new FormOption('Other'),
];

}